import React from 'react';
import { useSelector } from 'react-redux';
import { getThemeSelector } from '@src/store/selectors';

import { InfoContent, LogoContent, TitleContent, ImageContent } from './style';
import LoginImage from './login.png';

const Info = (): JSX.Element => {
	const { themes: { logo_link, name } } = useSelector(getThemeSelector) as {
		themes: { logo_link: string; name: string; }
	};
	return (
		<InfoContent>
			{ logo_link?.link && <LogoContent src={logo_link?.link} />}
			<TitleContent>{name}</TitleContent>
			<ImageContent src={LoginImage} />
		</InfoContent>
	);
};

export default Info;
